// extracted by mini-css-extract-plugin
export default {"DeleteableItemContainer":"DeleteableItem_DeleteableItemContainer__gfH9R"};